import { FC, useEffect, useRef } from "react";
import { RatioImageType } from "../types/CommonComponents";

const RatioImage: FC<RatioImageType> = (props) => {
  const bgImg = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const image = bgImg.current;
    if (image && image.classList.contains("bg-img")) {
      const parentElement = image.parentElement;
      if (parentElement) {
        parentElement.classList.add("bg-size");
        image.style.display = "none";
        parentElement.style.backgroundImage = `url(${props.src})`;
        parentElement.style.backgroundSize = "cover";
        parentElement.style.backgroundPosition = "center";
        parentElement.style.backgroundRepeat = "no-repeat";
      }
    }
  }, [props.src]);

  // NOTE: bgImg ref is intentionally not attached — the effect above is inert and
  // images render as plain <img> tags. loading="lazy" defers off-screen images so
  // image-heavy pages (e.g. the car listing) don't decode everything at once and
  // exhaust memory on iOS Safari ("A problem repeatedly occurred").
  return <img {...props} alt={props.alt || "image"} loading="lazy" decoding="async" />;
};
export default RatioImage;
